<template>
  <div class="cart">
    <section class="my-title">
      <div class="container">
        <div class="d-flex align-items-center justify-content-between">
          <div
            class="title-left d-flex align-items-center justify-content-between"
          >
            <img src="/media/icons/svg/cart-black.svg" alt="carrello" />
            <span>{{ trans.get("b2b.cart.cart") }}</span>
          </div>
          <div class="title-right">
            <img
              @click="closeMe()"
              src="/media/icons/svg/x-grey.svg"
              alt="X"
            />
          </div>
        </div>
      </div>
    </section>
    <section class="cart-content">
      <div class="cart-item"></div>
    </section>
    <section class="total">
      <div class="container">
        <div class="d-flex align-items-center justify-content-between">
          <span>{{ trans.get("b2b.article.total") }}</span>
          <span>0.00€</span>
        </div>
      </div>
    </section>
    <section class="call-checkout">
      <a class="link-ret green btn btn-my-primary giallo">Vai al Checkout</a>
    </section>
  </div>
</template>

<script>
export default {
  data: function () {
    return {};
  },
  mounted() {},
  methods: {
    closeMe: function () {
         this.$emit('closeMe');
    },
  },
};
</script>

<style lang="scss" scoped>
.cart {
  background-color: #fff;
  width: 778px;
  border: 1px solid #979797;
  .my-title {
    padding: 23px 42px;
    span {
      margin-left: 20px;
      font-size: 24px;
    }
    .title-right {
      cursor: pointer;
    }
  }
  .total {
    background-color: #26262a;
    color: #fff;
    .container {
      padding: 37px 69px;
    }
  }
  .call-checkout {
    a {
      width: 100%;
      padding: 36px 69px;
    }
  }
}
</style>